import React, { useState } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { MemberState } from '../../../../../types/zinantis/members/membersType';
import Tooltip from '../../../../../muiComponents/Tooltip';
import Flag from '../../../components/Flag';
import Image from '../../../../components/Image';
import MemberPanel from '../panel/MemberPanel';
import DotIcon from '../../../../components/DotIcon';
import Tag from '../../../../../muiComponents/Tag';
import variables from '../../../../../stylesheets/variables.module.scss';

interface MemberRowProps {
    member: MemberState;
    visibleSegmentName?: boolean;
    visibleNewMember?: boolean;
}
const MemberRow = (props: MemberRowProps) => {
    const { member, visibleSegmentName, visibleNewMember } = props;
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);

    return (
        <>
            <TableRow
                key={member.id}
                className={`member-card ${
                    !member.connected ? '--disconnected' : ''
                }`}
                onClick={() => setIsPopUpOpen(true)}
            >
                <TableCell
                    sx={{
                        width: '60px',
                        maxWidth: '60px',
                        textAlign: 'center',
                    }}
                >
                    <Tooltip
                        titleText={
                            member?.connected ? 'connected' : 'disconnected'
                        }
                    >
                        <span>
                            <DotIcon
                                truthy={member?.connected}
                                falsy={!member?.connected}
                            />
                        </span>
                    </Tooltip>
                </TableCell>

                <TableCell className='font-weight-600 text-size-16'>
                    <div className='flex gap-20'>
                        {member.name}
                        {visibleNewMember && member.isNew && (
                            <span className='member-row__new-tag'>
                                <Tag
                                    text='new'
                                    color={variables.accentColorPink400}
                                />
                            </span>
                        )}
                    </div>
                </TableCell>
                {visibleSegmentName && (
                    <TableCell>{member.accountManagmentSegment}</TableCell>
                )}
                <TableCell
                    sx={{
                        width: '250px',
                        maxWidth: '250px',
                    }}
                >
                    <div className='flex gap-5 flex-align-center'>
                        {member.countryCode && (
                            <Flag
                                text={member.country}
                                code={member.countryCode}
                            />
                        )}

                        <p>{member.country}</p>
                    </div>
                </TableCell>
                <TableCell
                    sx={{
                        width: '120px',
                        maxWidth: '120px',
                    }}
                >
                    <div className='member__logo-container'>
                        {member.logo ? (
                            <Image
                                className='member__image'
                                src={member.logo}
                            />
                        ) : (
                            <div className='member__logo-name'>
                                <p className='multiline-overflow__2'>
                                    {member.name}
                                </p>
                            </div>
                        )}
                    </div>
                </TableCell>
            </TableRow>
            {isPopUpOpen && (
                <MemberPanel
                    open={isPopUpOpen}
                    onClose={() => setIsPopUpOpen(false)}
                    memberId={member.id}
                    isConnected={!!member.connected}
                    memberHotels={member.hotels}
                />
            )}
        </>
    );
};

export default MemberRow;
